import React from 'react'
import { useAuthContext } from '../../../context/auth'
import EmailVerification from './EmailVerification'

const AccountNotice = () => {
	const { auth } = useAuthContext()
	return <>{auth.user && !auth.user.emailVerified && <EmailVerification />}</>
}

export default AccountNotice
